import { useSetAtom } from 'jotai';

import { useGetConsents } from 'src/hooks/useGetConsents';
import {
  coerceUnsupportedKmcConsentCombinationAtom,
  freezeSmsPreVerificationMethodAtom,
} from 'src/stores/register/atoms';
import { LoginType } from 'src/types/register';

const usePrepareSocialKmc = () => {
  const freezeSmsPreVerificationMethod = useSetAtom(freezeSmsPreVerificationMethodAtom);
  const coerceUnsupportedKmcConsentCombination = useSetAtom(
    coerceUnsupportedKmcConsentCombinationAtom
  );
  const { data: consentsData } = useGetConsents();
  const { uiType: consentsUiType } = consentsData?.data?.result || {};

  const prepareSocialKmc = (loginType?: LoginType) => {
    // Apple은 freeze 시점에 enabledSignupWithApple을 보고 KMC로 고정하지 않는다.
    freezeSmsPreVerificationMethod(loginType);
    // KR은 CONSENT_A만 배포하므로 CONSENT_B + KMC는 지원하지 않는다.
    // signup-settings가 방어적으로 KMC를 내려주더라도 TSP로 강등해 SMS 플로우로 진행한다.
    coerceUnsupportedKmcConsentCombination(consentsUiType);
  };

  return { prepareSocialKmc };
};

export default usePrepareSocialKmc;
